import { Navigate, useLocation } from 'react-router';

import { ADMIN_ROOT, legacyAdminTarget } from '@/platform/lib/admin';

/** Bookmarks from before `/verwaltung`: `/benutzer/…`, `/abteilungen`, `/teams`, `/audit`. */
export function LegacyAdminRedirect() {
  const { pathname, search, hash } = useLocation();
  return (
    <Navigate to={{ pathname: legacyAdminTarget(pathname) ?? ADMIN_ROOT, search, hash }} replace />
  );
}
